import { MouseEvent, useState } from 'react';
import { CheckIcon, CopyIcon } from 'lucide-react';

import styles from './copyable-text.module.scss';

type Props = {
    text: string;
};

const CopyableText = ({ text }: Props) => {
    const [icon, setIcon] = useState(<CopyIcon size={18} color="#505f75" />);

    const handleClick = (ev: MouseEvent) => {
        ev.preventDefault();
        setIcon(<CheckIcon size={18} color="#505f75" />);
        const clipboardItem = new ClipboardItem({ 'text/plain': text });
        navigator.clipboard.write([clipboardItem]);

        setTimeout(() => setIcon(<CopyIcon size={18} color="#505f75" />), 800);
    };
    return (
        <div className={styles.container}>
            <label>{text}</label>
            <button onClick={handleClick}>{icon}</button>
        </div>
    );
};

export { CopyableText };
